import {
  Listbox,
  ListboxButton as HUListboxButton,
  ListboxButtonProps,
  ListboxOption as HUListboxOption,
  ListboxOptionProps,
  ListboxOptions as HUListboxOptions,
} from '@headlessui/react'
import styled from 'styled-components'

import Check from '@/assets/svgs/check-line.svg'
import Chevron from '@/assets/svgs/chevron.svg'
import { textSizeM } from '@/styles/theme/fonts.ts'

const ListboxButtonStyled = styled(HUListboxButton)`
  ${textSizeM};
  width: 100%;
  padding: 12px 48px 12px 16px;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.common.border};
  background-color: ${({ theme }) => theme.colors.common.white};
  color: ${({ theme }) => theme.colors.common.black75};

  &[data-open] {
    color: ${({ theme }) => theme.colors.common.black62};
    border-bottom: 0;
  }
`

const ListboxIcon = styled.img`
  position: absolute;
  right: 12px;
  transform: rotate(0);
  transition: transform 0.2s ease-in-out;
  justify-self: flex-end;

  ${ListboxButtonStyled}[aria-expanded=true] & {
    transform: rotate(180deg);
  }
`

const ListboxButton = ({ children, ...props }: ListboxButtonProps) => {
  return (
    <ListboxButtonStyled {...props}>
      <>
        {children}
        <ListboxIcon src={Chevron} alt="chevron icon" />
      </>
    </ListboxButtonStyled>
  )
}

const ListboxOptionStyled = styled(HUListboxOption)`
  ${textSizeM};
  cursor: pointer;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  &[aria-selected='true'] {
    color: ${({ theme }) => theme.colors.common.accentDark};
  }
`

const CheckIcon = styled.img`
  width: 24px;
  height: 24px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  ${ListboxOptionStyled}[aria-selected=true] & {
    opacity: 1;
  }
`

const ListboxOption = ({ children, ...props }: ListboxOptionProps) => {
  return (
    <ListboxOptionStyled {...props}>
      <>{children}</>
      <CheckIcon src={Check} alt="check icon" />
    </ListboxOptionStyled>
  )
}

const ListboxOptions = styled(HUListboxOptions)`
  &[data-open] {
    border: 1px solid ${({ theme }) => theme.colors.common.border};
    border-top: 0;
    padding-top: 0;
  }
  padding: 4px 0;
  border-radius: 0 0 2px 2px;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
`

export { Listbox, ListboxButton, ListboxOption, ListboxOptions }
